import * as Sentry from '@sentry/react';

/*
 * Similar to console.log except thta it doesn't log to console
 * but logs to Sentry breadcrumbs in Web and in log files on Desktop.
 * Useful for gathering log information without dumping the data to real console.
 */
export const logForDebug: typeof console.log = (...params) => {
  _logForDebug(...params);
  Sentry.addBreadcrumb({
    category: 'auth',
    message: JSON.stringify(params),
    level: 'info',
  });
};

let _logForDebug: typeof console.log = () => {};
export function setLogForDebug(func: typeof console.log) {
  _logForDebug = func;
}
